var props = {
  name: {
    type: String,
    "default": "",
    required: true
  },
  size: {
    type: String,
    "default": void 0
  },
  tag: {
    type: String,
    "default": "i"
  },
  url: {
    type: [String, Array],
    "default": void 0
  },
  loadDefaultIcons: {
    type: Boolean,
    "default": true
  },
  onClick: Function
};

export { props as default };
//# sourceMappingURL=props.js.map
